import { Link } from "react-router-dom";

export default function IconShorting({ activeDirection }) {
  return (
    <Link to="#">
      {activeDirection === "asc" ? (
        // 🔼 Up (ascending)
        <svg
          id="fi_10407117"
          enableBackground="new 0 0 32 32"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          width="18px"
          height="18px"
        >
          <path d="m2.3037109 11.4589844c.194336.1884765.4453125.2822265.6962891.2822265.2607422 0 .5214844-.1015625.7177734-.3037109l2.1279907-2.1931152.0004272 15.9821777c0 .5527344.4477539 1 1 1s1-.4472656 1-1l-.0004271-15.9821777 2.1283569 2.1931152c.3852539.3964844 1.0180664.40625 1.4140625.0214844.3964844-.3847656.4057617-1.0175781.0214844-1.4140625l-3.8461914-3.9638672c-.0003052-.0003662-.0008545-.0004273-.0011597-.0007935-.1818237-.1880493-.4343262-.3068237-.7166138-.3068237s-.53479.1187744-.7166138.3068237c-.0003051.0003662-.0008544.0004273-.0011596.0007935l-3.8457031 3.9638672c-.3847657.3964843-.375 1.0292969.0214843 1.4140625z"></path>
          <path d="m26.8798828 12.9228516c0-.5527344-.4477539-1-1-1h-10.8515625c-.5522461 0-1 .4472656-1 1s.4477539 1 1 1h10.8515625c.5522461 0 1-.4472657 1-1z"></path>
          <path d="m23.7597656 19.0732422c0-.5527344-.4477539-1-1-1h-7.7314453c-.5522461 0-1 .4472656-1 1s.4477539 1 1 1h7.7314453c.5522461 0 1-.4472656 1-1z"></path>
          <path d="m15.0283203 24.2265625c-.5522461 0-1 .4472656-1 1s.4477539 1 1 1h4.6118164c.5522461 0 1-.4472656 1-1s-.4477539-1-1-1z"></path>
          <path d="m29 5.7734375h-13.9716797c-.5522461 0-1 .4472656-1 1s.4477539 1 1 1h13.9716797c.5522461 0 1-.4472656 1-1s-.4477539-1-1-1z"></path>
        </svg>
      ) : (
        // 🔽 Down (descending)
        <svg
          id="fi_10407118"
          enableBackground="new 0 0 32 32"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          width="18px"
          height="18px"
        >
          <path d="m2.3037109 20.5410156c-.3964844.3847656-.40625 1.0175781-.0214844 1.4140625l3.8457031 3.9638672c.0002441.0002441.0006104.0003662.0008545.0006104.1817627.1881104.4343262.3070068.7169189.3070068s.5351562-.1188965.7169189-.3070068c.0002441-.0002441.0006104-.0003662.0008545-.0006104l3.8466797-3.9638672c.3847656-.3964844.375-1.0292969-.0214844-1.4140625s-1.0292969-.375-1.4140625.0214844l-2.1289062 2.1940308v-15.9830933c0-.5527344-.4472656-1-1-1s-1 .4472656-1 1v15.9827881l-2.1279296-2.1937256c-.3847656-.3964844-1.0175781-.40625-1.4140625-.0214844z"></path>
          <path d="m26.8798828 12.9228516c0-.5527344-.4472656-1-1-1h-10.8515625c-.5527344 0-1 .4472656-1 1s.4472656 1 1 1h10.8515625c.5527344 0 1-.4472657 1-1z"></path>
          <path d="m23.7597656 19.0732422c0-.5527344-.4472752-1-1-1h-7.7314453c-.5527344 0-1 .4472656-1 1s.4472656 1 1 1h7.7314453c.5527249 0 1-.4472656 1-1z"></path>
          <path d="m15.0283203 24.2265625c-.5527344 0-1 .4472656-1 1s.4472656 1 1 1h4.6113281c.5527344 0 1-.4472656 1-1s-.4472656-1-1-1z"></path>
          <path d="m29 5.7734375h-13.9716797c-.5527344 0-1 .4472656-1 1s.4472656 1 1 1h13.9716797c.5527344 0 1-.4472656 1-1s-.4472656-1-1-1z"></path>
        </svg>
      )}
    </Link>
  );
}
